import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeseven-main-banner',
  templateUrl: './homeseven-main-banner.component.html',
  styleUrls: ['./homeseven-main-banner.component.scss']
})
export class HomesevenMainBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
